import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import ContactSection from "../../components/pages/home/contact-section/ContactSection";
import HeroSection from "../../components/pages/home/hero-section/HeroSection";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import OurWorkSection from "../../components/pages/home/our-work-section/OurWorkSection";
import ServicesNetworkSection from "../../components/pages/home/service-network-section/ServicesNetworkSection";
import TariffCalculatorSection from "../../components/pages/home/tariff-calculator-section/TariffCalculatorSection";
import TariffsSection from "../../components/pages/home/tariffs-sections/TariffsSection";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import Innovations from "../innovations/Innovations";
import { RootState } from "../../redux/store";
import styles from "../../components/shared/popup/Pop-up.module.scss";
import closeIcon from "../../assets/images/modal-icon/CloseIcon.svg";
import { PopupServices } from "../../services/popup.service";
import { PopupDatatype } from "../../interface/site.interface";
import { getCookie, setCookie } from "../../utils/utils";

const Home = () => {
  const { data } = useSelector((state: RootState) => state.translationData);
  const [showModal, setShowModal] = useState(false);
  const [popupData, setPopupData] = useState<PopupDatatype[]>([]);
  const [popupVersion, setPopupVersion] = useState<string>("");

  useEffect(() => {
    const savedPopupVersion = getCookie("X-Popup-Version") || "";
    setPopupVersion(savedPopupVersion);

    PopupServices.getPopUp().then((res) => {
    if (res.isActive) {
      setPopupData([res.data]);

      PopupServices.checkPopupStatus(savedPopupVersion).then((versionRes) => {
        setShowModal(versionRes.data?.show);
        const version = versionRes.data?.version || versionRes.version;
        if (version) {
          setPopupVersion(version);
        }
      });
    } else {
      setShowModal(false);
    }
  });
  }, []);

  const handleClose = async () => {
    setShowModal(false);
    if (!popupVersion) return;
    try {
      const res = await PopupServices.closePopUp(popupVersion);
      const newVersion = res?.data?.version || res?.newVersion || res?.data?.["X-Popup-Version"];
      if (newVersion) {
        setCookie("X-Popup-Version", newVersion, 365);
        setPopupVersion(newVersion);
      }
    } catch (error) {
      console.error("Popup bağlanarkən xəta:", error);
    }
  };

  return (
    <div>
      {showModal && (
        <div className={styles.popup_overlay}>
          <div className={styles.popup_modal}>
            <button className={styles.popup_closeBtn} onClick={() => setShowModal(false)}>
              <img src={closeIcon} alt="close" />
            </button>
            <div className={styles.popupContent}>
              {popupData.map((popup, index) => (
                <div key={index} className={styles.popupContent}>
                  <h2
                    className={styles.title}
                    dangerouslySetInnerHTML={{ __html: popup?.popUp }}
                  ></h2>
                  <p
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: popup?.popUpText }}
                  ></p>
                </div>
              ))}
              <button className={styles.popup_dismissBtn} onClick={handleClose}>
                {data?.popup_dismiss || "Bir daha göstərmə"}
              </button>
            </div>
          </div>
        </div>
      )}

      <TitleUpdater
        title={data?.home_seo_title || "Colibri Express — Sürətli Yol, Təhlükəsiz Çatdırılma"}
        description={data?.home_seo_description}
        keywords={data?.home_seo_keywords}
      />

      <HeroSection />
      <OurWorkSection />
      <Innovations />
      <TariffsSection />
      <TariffCalculatorSection />
      <ServicesNetworkSection />
      <ContactSection />
      <MobileAppSection />
    </div>
  );
};

export default Home;
